import {
  SET_LANGUAGES_AVAILABLE,
  SET_LANGUAGES_TESTGROUP,
  SET_TESTGROUP_ADVANCED_SETTING,
  SET_TESTGROUP_THEME_TOGGLE,
  SET_TESTGROUP_TO_TRANSLATE,
  SET_TRANSLATE_TEST,
  SET_TRANSLATE_TESTGROUP_LOADING,
  SET_TRANSLATED_TESTS,
} from '../actionTypes';

const initialState = {
  testgroupTranslated: {
    description: '',
    level: undefined,
    category: undefined,
    categories: [],
    rolesIds: [],
    tagsIds: [],
    endorsementId: '',
    companyUsageIds: [],
    withThemes: undefined,
    withoutTime: false,
    customStep: undefined,
    objetives: {},
    detail: {},
    summary: {},
    minimumTier: undefined,
    languages: [],
    testFormatIds: [],
    withCustomLangCodesAI: false,
    tests: [],
  },
  testToTranslate: null,
  loadingTestgroup: false,
  translatedTests: [],
  originalLanguage: null,
  originalIsoCode: null,
  languageToTranslate: null,
  isoCodeToTranslate: null,
  languagesAvailable: [],
  testgroupWithThemes: false,
  advancedSetting: null,
};

function testgroupCreateorReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TESTGROUP_TO_TRANSLATE: {
      return { ...state, ...action.payload };
    }
    case SET_TRANSLATE_TEST: {
      return { ...state, ...action.payload };
    }
    case SET_TRANSLATE_TESTGROUP_LOADING: {
      return { ...state, loadingTestgroup: action.payload };
    }
    case SET_LANGUAGES_TESTGROUP: {
      return { ...state, ...action.payload };
    }
    case SET_TRANSLATED_TESTS: {
      return { ...state, ...action.payload };
    }
    case SET_LANGUAGES_AVAILABLE: {
      return { ...state, languagesAvailable: action.payload };
    }
    case SET_TESTGROUP_THEME_TOGGLE: {
      return { ...state, ...action.payload };
    }
    case SET_TESTGROUP_ADVANCED_SETTING: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
}

export default testgroupCreateorReducer;
